module.exports = __webpack_public_path__ + "static/media/creativity1.bad5dbf3.jpg";